var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header'),_c('main',{staticClass:"flex-grow-1 overflow-hidden",attrs:{"data-layout":"wide"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }